import { useApolloClientRefetch } from '@pay-bill/hooks/use-apollo-refetcher';
import { useCallback } from 'react';

export const useDisputeRefetchs = () => {
  const refetchQueries = useApolloClientRefetch();

  return useCallback(() => {
    refetchQueries([
      'PaginatedDisputesList',
      'PaginatedInvItemsList',
      'PaginatedReverseInvoicesList',
      'PaginatedInvoicesQuery',
    ]);
  }, [refetchQueries]);
};
